import { FC } from 'react';
import { PhotosSearchBrowseBackLink } from './PhotosSearchBrowseBackLink';
import { useHeadlineContext } from './PhotosSearchBrowseHeadlineContext';
import styles from './PhotosSearchBrowseWrapperHeader.scss';

export const PhotosSearchBrowseWrapperHeader: FC = () => {
    const headline = useHeadlineContext();
    return (
        <div className={styles.wrapper} data-tn="photos-header">
            <h1 className={styles.header}>{headline}</h1>
            <PhotosSearchBrowseBackLink />
        </div>
    );
};
